export const IConfigurationRepositoryType = Symbol('IConfigurationRepository');
